/*
  Glue between the Rebuy cart cross-sell widget and the native mini-cart.
  1. Render the widget on load via Rebuy.init().
  2. Refresh the mini-cart once after a shopper adds from the widget.

  Listens ONLY to `rebuy:cart.add`, never `rebuy:cart.change`: cart.change fires
  on any cart activity (including our own refresh POST), which looped forever and
  reset the scroll. No-ops if window.Rebuy (the app embed) never loads.
  Reference: https://help.rebuyengine.com/en/articles/6120657
*/
(function () {
  var miniCart = document.querySelector('hh-mini-cart');
  if (!miniCart) return;
  if (!miniCart.querySelector('[data-rebuy-id]')) return;

  /* Run `fn` once Rebuy is available (retry only until the engine loads). */
  function whenReady(fn) {
    var tries = 0;
    (function poll() {
      if (window.Rebuy && typeof window.Rebuy.init === 'function') {
        fn();
        return;
      }
      if (tries++ < 40) setTimeout(poll, 250);
    })();
  }

  /* 1. Render the widget on load. */
  whenReady(function () {
    window.Rebuy.init();
  });

  /* 2. Refresh after an add. Mirrors the theme's reRenderShopifySections. */
  function reRenderSections(sections) {
    Object.keys(sections).forEach(function (key) {
      var updated = new DOMParser()
        .parseFromString(sections[key], 'text/html')
        .querySelectorAll('[data-rerender]');
      var host = document.querySelector(
        '[id^="shopify-section-"][id*="' + key + '"]'
      );
      if (!host) return;
      host.querySelectorAll('[data-rerender]').forEach(function (node, i) {
        if (updated[i]) node.replaceWith(updated[i]);
      });
    });
  }

  /* True while a refresh is in flight; ignores stray events so it can't loop. */
  var busy = false;

  function refreshMiniCart() {
    if (busy) return;
    busy = true;
    var url =
      (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sections: 'mini-cart,header' }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data && data.sections) {
          reRenderSections(data.sections);
          whenReady(function () {
            window.Rebuy.init();
          });
        }
      })
      .catch(function () {
        /* best-effort */
      })
      .finally(function () {
        /* Release late so Rebuy's cart.change for our own POST lands while busy. */
        setTimeout(function () {
          busy = false;
        }, 300);
      });
  }

  document.addEventListener('rebuy:cart.add', refreshMiniCart);
})();
